export default __webpack_public_path__ + "static/media/sofa-3-seat-3-back.db35c325.webp";